/**
 *
 * @param filtersValues from srpFiltersDuck.selectors.getFiltersValues
 * @param multiYear boolean to determine if an array of make models from current year and next year should be the vrs search
 * @returns [Array] of objects that contain the unique make-model pairs in the search
 */
export default function getUniqueMakeModelPairs({ filtersValues, multiYear = false }) {
    const makeModelPairs = [];
    Object.entries(filtersValues).forEach(([key, value]) => {
        // TODO atc series code does not map to vrs series code || key.includes('seriesCode')
        if (key.includes('modelCode')) {
            const makeName = key.split('|')?.[1];
            value?.forEach((model) => {
                makeModelPairs.push({
                    makeModel: `${makeName}-${model}`,
                    makeCode: makeName,
                    modelCode: model,
                });
            });
        }
    });
    if (multiYear) {
        const currentYear = new Date().getFullYear();
        const nextYear = currentYear + 1;
        const years = [nextYear, currentYear];

        const multiYearPairs = [];

        years.forEach((year) => {
            makeModelPairs.forEach((pair) => {
                multiYearPairs.push({
                    ...pair,
                    makeModel: `${pair.makeModel}-${year}`,
                    year,
                });
            });
        });
        return multiYearPairs;
    }
    return makeModelPairs;
}
